module.exports = "./assets/assets/竞争性磋商(服务).381bf39a.docx";